import { http, HttpResponse } from 'msw';

import { Consent } from 'services/consent/queries/useConsent/useConsent.interface';
import { ConsentName } from 'modules/common/types/ConsentName.constants';

const defaultConsents: Consent[] = [
    {
        name: ConsentName.TERMS_OF_SERVICE,
        version: 1,
        content: '<h2>Terms of Service</h2><p>Default terms of service body.</p>',
        content_type: 'HTML',
        is_signature_required: true,
    },
    {
        name: ConsentName.PRIVACY_POLICY,
        version: 1,
        content: '<h2>Privacy Policy</h2><p>Default privacy policy body.</p>',
        content_type: 'HTML',
        is_signature_required: false,
    },
    {
        name: ConsentName.TRANSACTIONAL_SMS_MESSAGES,
        version: 1,
        content: 'Text me account and support updates <em>(recommended)</em>',
        content_type: 'HTML',
        is_signature_required: false,
    },
    {
        name: ConsentName.MARKETING_SMS_MESSAGES,
        version: 1,
        content: 'Text me promotional messages from Collective',
        content_type: 'HTML',
        is_signature_required: false,
    },
    {
        name: ConsentName.TAX_DISCLOSURE,
        version: 1,
        content:
            '<h2>Tax Disclosure</h2><p>I authorize Collective Hub, Inc. to use my tax return information for the bookkeeping, payroll, tax planning, and advisory services I have signed up for.</p>',
        content_type: 'HTML',
        is_signature_required: true,
    },
];

export default {
    latestConsents: http.get('*/legalconsents/api/consents/latest_consents/', () =>
        HttpResponse.json({
            count: defaultConsents.length,
            next: null,
            previous: null,
            results: defaultConsents,
        })
    ),
    createUserConsent: http.post('*/legalconsents/api/user-consents/:userId/', async ({ request }) => {
        const body = (await request.json()) as Record<string, unknown>;
        return HttpResponse.json({ id: 'mock-consent-id', ...body, created_at: new Date().toISOString() });
    }),
};
